export interface Author {
    email?: string;
    github?: string;
    homepage?: string;
    username: string;
    weibo?: string;
}
